import "../css/Reviews.css";

const reviews = [
  {
    text: "This place feels like a pause button on the city.",
    author: "Daniel R.",
  },
  {
    text: "I come here after work when I want silence and good coffee.",
    author: "Aisha K.",
  },
  {
    text: "Neo Café understands that night needs calm, not noise.",
    author: "Marco L.",
  },
  {
    text: "The lighting alone makes you slow down.",
    author: "Sophia N.",
  },
  {
    text: "It’s not just coffee — it’s atmosphere.",
    author: "Jonas W.",
  },
];

const Reviews = () => {
  return (
    <main className="night-reviews">

      {/* INTRO */}
      <section className="reviews-intro">
        <h1>Reviews</h1>
        <p>
          Words from people<br />
          who stayed longer.
        </p>
      </section>

      {/* QUOTES */}
      <section className="reviews-list">
        {reviews.map((review, index) => (
          <blockquote key={index}>
            <p>“{review.text}”</p>
            <span>{review.author}</span>
          </blockquote>
        ))}
      </section>

      {/* CLOSING */}
      <section className="reviews-closing">
        <p>
          Every night leaves a memory.<br />
          Some stay longer.
        </p>
      </section>

    </main>
  );
};

export default Reviews;
